import React from 'react';
import { Bell, AlertTriangle, Info, ShieldAlert } from 'lucide-react';

const SEVERITY = {
  info:  { icon: Info,        color: '#1F4480', bg: '#E8EFFF' },
  warn:  { icon: AlertTriangle,color: '#8D6912', bg: '#FFF1C2' },
  alert: { icon: ShieldAlert, color: '#A52828', bg: '#FFDADA' },
};

export default function AlertsCard({ data, loading }) {
  if (loading) {
    return (
      <div className="puvio-card p-5" data-testid="alerts-card-skeleton">
        <div className="puvio-skeleton h-6 w-32 mb-3" />
        <div className="puvio-skeleton h-4 w-full mb-2" />
        <div className="puvio-skeleton h-4 w-5/6 mb-2" />
        <div className="puvio-skeleton h-4 w-4/6" />
      </div>
    );
  }
  const items = data?.alerts || [];
  return (
    <div className="puvio-card p-5" data-testid="alerts-card">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]">Local alerts</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">Stay aware in {data?.city || 'your city'}</p>
        </div>
        <div className="w-10 h-10 rounded-2xl bg-[var(--puvio-bg-soft)] flex items-center justify-center">
          <Bell className="w-5 h-5 text-[#0F1A13]" />
        </div>
      </div>
      {items.length === 0 && <p className="text-sm text-[var(--puvio-text-2)] font-medium">No alerts right now. Enjoy your visit!</p>}
      <ul className="flex flex-col gap-3">
        {items.map((a, i) => {
          const s = SEVERITY[a.severity] || SEVERITY.info;
          const Icon = s.icon;
          return (
            <li key={i} className="flex gap-3 items-start" data-testid={`alert-item-${i}`}>
              <span className="w-8 h-8 rounded-full flex items-center justify-center shrink-0" style={{ background: s.bg, color: s.color }}>
                <Icon className="w-4 h-4" />
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-extrabold text-[#0F1A13] leading-tight">{a.title}</p>
                <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 leading-snug font-medium">{a.body}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
